import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=6ec9cb42&scoped=true"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectPage.vue?vue&type=style&index=0&id=6ec9cb42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec9cb42",
  null
  
)

export default component.exports